module.exports = __webpack_public_path__ + "static/media/loader.aad2b11b.svg";